export default {
  apiRoot: 'https://staging.webassess.com/api/v1/',
  vueLogErrors: true,
  sentryDsn: 'https://34e01f055d734640928ff867d1ae0591@sentry.atleta.hu/20',
  routerMode: 'history'
  // routerMode: 'hash'
}
